import axiosInstance from '../services/AxiosInstance';

// Existing CRUD endpoints (adjust as needed)
const API_URL = '/courses'; // adjust to your actual API path
const BILLING_COURSES_URL = '/courses/billing-courses';
const BILLING_BRANCHES_URL = '/branches';
const BILLING_DEPARTMENTS_URL = '/departments';

// ========== Course CRUD ==========
export const getcourses = async (
  limit = 10,
  page = 1,
  search = '',
  searchField = 'all'
) => {
  try {
    const params = {
      limit: Number(limit),
      page: Number(page),
    };
    if (search && search.trim() !== '') {
      params.search = search.trim();
      params.searchField = searchField;
    }
    const response = await axiosInstance.get(API_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses', error);
    throw error;
  }
};

export const getcoursesById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching course by id', error);
    throw error;
  }
};

export const createcourses = async (courseData) => {
  try {
    const response = await axiosInstance.post(API_URL, courseData);
    return response.data;
  } catch (error) {
    console.error('Error creating course', error);
    throw error;
  }
};

export const updatecourses = async (id, courseData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${id}`, courseData);
    return response.data;
  } catch (error) {
    console.error('Error updating course', error);
    throw error;
  }
};

export const deletecourses = async (id, hardDelete = false) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${id}?hardDelete=${hardDelete}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting course', error);
    throw error;
  }
};

// ========== Billing endpoints (for dropdowns) ==========
// Get courses from billing-courses (returns data and pagination)
export const getBillingCourses = async (limit = 20, page = 1, search = '') => {
  try {
    const params = {
      limit: Number(limit),
      page: Number(page),
    };
    if (search && search.trim() !== '') {
      params.search = search.trim();
    }
    const response = await axiosInstance.get(BILLING_COURSES_URL, { params });
    // Assuming response.data has { data: [...], pagination: { ... } }
    return response.data;
  } catch (error) {
    console.error('Error fetching billing courses', error);
    throw error;
  }
};

// Get branches from billing-branches
export const getBillingBranches = async (limit = 20, page = 1, search = '') => {
  try {
    const params = {
      limit: Number(limit),
      page: Number(page),
    };
    if (search && search.trim() !== '') {
      params.search = search.trim();
    }
    const response = await axiosInstance.get(BILLING_BRANCHES_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching billing branches', error);
    throw error;
  }
};

// Get departments from billing-departments
export const getBillingDepartments = async (limit = 20, page = 1, search = '') => {
  try {
    const params = {
      limit: Number(limit),
      page: Number(page),
    };
    if (search && search.trim() !== '') {
      params.search = search.trim();
    }
    const response = await axiosInstance.get(BILLING_DEPARTMENTS_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching billing departments', error);
    throw error;
  }
};